export default "__VITE_ASSET__Behax7MJ__"